
import { AnalysisResult } from './types';

// Visualization helper functions
export const createFocusAreaChartData = (analysisResult: AnalysisResult | null) => {
  if (!analysisResult?.focusAreas) return [];
  
  return analysisResult.focusAreas.map((area, index) => ({
    name: area.title,
    value: 100 - index * 20, // Decreasing importance
    kpis: area.kpiAlignment.length
  }));
};

export const createImpactPieData = (analysisResult: AnalysisResult | null) => {
  if (!analysisResult?.kpiImpactAnalysis?.topKpis) return [];
  
  const total = analysisResult.kpiImpactAnalysis.topKpis.length;
  return analysisResult.kpiImpactAnalysis.topKpis.map((kpi) => ({
    name: kpi,
    value: 100 / total
  }));
};

export const createTimelineData = (analysisResult: AnalysisResult | null) => {
  if (!analysisResult?.salesActivities) return [];
  
  return analysisResult.salesActivities.map(activity => {
    let value = 33;
    if (activity.timeline.toLowerCase().includes('short')) value = 30;
    if (activity.timeline.toLowerCase().includes('medium')) value = 60;
    if (activity.timeline.toLowerCase().includes('long')) value = 90;
    
    return {
      name: activity.activity,
      value,
      impact: activity.impact
    };
  });
};

export const createOpportunityChartData = (analysisResult: AnalysisResult | null) => {
  if (!analysisResult?.revenueOpportunities) return [];
  
  return analysisResult.revenueOpportunities.map(opp => {
    let value = 50;
    if (opp.potential.toLowerCase().includes('high')) value = 90;
    if (opp.potential.toLowerCase().includes('medium')) value = 60;
    if (opp.potential.toLowerCase().includes('low')) value = 30;
    
    return {
      name: opp.opportunity,
      value,
      timeline: opp.timeline
    };
  });
};

export const createRiskHeatmapData = (analysisResult: AnalysisResult | null) => {
  if (!analysisResult?.riskMitigation) return [];
  
  return analysisResult.riskMitigation.map(risk => {
    let value = 50;
    if (risk.impact.toLowerCase().includes('high')) value = 85;
    if (risk.impact.toLowerCase().includes('medium')) value = 55;
    if (risk.impact.toLowerCase().includes('low')) value = 25;
    
    return {
      name: risk.risk,
      value,
      mitigation: risk.mitigation
    };
  });
};
